import Typography from '@/ui/components/typography'
import { RuleSectionProps } from './RuleSection.types'
import { SectionHeader } from '../SectionHeader'
import { Section, SubSection, SubSectionTitle } from './RuleSection.styles'
import ItemsList from './ItemsList/ItemsList'
import { startCase } from 'lodash'

const RuleSection = ({ title, items, dataTestId }: RuleSectionProps) => {
    return (
        <Section data-testid={dataTestId}>
            <SectionHeader title={title} />
            {items.map(({ name, values }, index) => (
                <SubSection key={`${name}-${index}`} data-testid={`${dataTestId}-item`}>
                    <SubSectionTitle data-testid={`${dataTestId}-name-${name}`}>
                        <Typography variant="s-semibold">
                            {startCase(name)}
                        </Typography>
                    </SubSectionTitle>
                    <ItemsList
                        items={values}
                        dataTestId={`${dataTestId}-value`}
                    />
                </SubSection>
            ))}
        </Section>
    )
}

export default RuleSection
